import { pricingPageUrl } from '@/environment';
import styled from '@emotion/styled';

const Container = styled.div`
    display: flex;
    height: 29px;
    align-items: center;
    background: ${({ theme }) => theme.colors.primary.main};
    position: relative;
    border-radius: inherit;
    padding: 3px;
`;

const Button = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    text-align: center;
`;

interface Props {
    show?: boolean;
}
export const UpgradeBanner = ({ show }: Props) => {
    const handleClick = () => {
        window.open(pricingPageUrl, '_blank');
    };

    if (!show) {
        return null;
    }

    return (
        <Container>
            <Button onClick={handleClick}>Upgrade to use</Button>
        </Container>
    );
};
